import {Tariff} from '../../components/consts'
import {AddressType, AddressValue, Params, PassportType} from './types'

const TariffParams: Record<string, string> = {
  [Tariff.COURIER]: 'Courier',
  [Tariff.EXPRESS]: 'Delivery',
  [Tariff.CARGO]: 'Cargo',
}

export const setUserID = (id: string): Params => ({
  __ym: {
    user_id: id,
  },
})
// фукнции строят дерево параметров для метрики, что-то в таком духе:
//   DeliveryOrder
//     OrderFrom
//       Entrance
//       Floor
//     OrderTariff
//       Delivery
//       Cargo
//         Type
//           Small
//           Medium
//           Large
// см. задачу https://st.yandex-team.ru/CARGODEV-2351 или спроси yakovenkovv
export const delivery = (params: Params | string): Params => ({DeliveryOrder: params})
export const address = (type: AddressType, value: AddressValue): Params => delivery({[type]: value})
export const tariff = (tariff: string, requirement?: Params): Params => {
  const t: string = TariffParams[tariff] || tariff
  const params: Params = requirement ? {OrderTariff: {[t]: requirement}} : {OrderTariff: t}

  return delivery(params)
}
export const payment = (): Params => delivery('CreditCard')
export const addPoint = () => delivery('OneMorePoint')
export const orderButton = (type: PassportType) => delivery({DefaultButton: type})
export const orderSuccess = (price: number, time: number): Params =>
  delivery({
    OrderPrice: price,
    OrderETA: time,
  })
